import React, { useState } from "react";
import "./hrtChecklistMeds.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  fetchPatientDetailsUuid,
  coupleIdChecker,
  postAppointment,
} from "../../Redux/Thunk/Actions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../../assets/images/ascas.svg";
import Headers from "../../Components/Header/Headers";
import { PrescriptionFooter } from "../../Components/Prescription Footer/PrescriptionFooter";
export default function HrtCheckListMeds(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector((state) => state.counter.patientid);

  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
    });
  const [patientOne_UUId, setPatientOne_UUId] = useState("");

  const handleChange = (e) => {
    // const { name, value } = e.target;
    // setFormData({ ...formData, [name]: value });
    var text = e.target.value;

    if (e.target.name === "patientId1") {
      if (/^(ASCAS|VDASCAS)\d+$/i.test((e.target.value || "").trim())) {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value,
          };
          props.loaderchange("true");
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat =
              data?.titles + " " + data?.first_name + " " + data?.last_name;
            if (e.target.name === "patientId1") {
              setPatientOne_UUId(data?.id);
              setFormData({
                ...formData,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text,
              });
            }
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === "patientId1") {
          setFormData({
            ...formData,
            patientId1: e.target.value,
          });
        }
      }
    } else {
      console.log("Going in");
      setFormData({ ...formData, [e.target.name]: e.target.value });
      if (e.target.name === "nextappointment") {
        const dateTime = e.target.value.split("T");
        setAppointmentData({
        ...appointmentData,
        date: dateTime[0],
        time: dateTime[1],
        p_uhid: props.patientsData.p_uhid,
        name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
        status: "Not Visited",
        notes: "Booking Visit",
        patient_id: patientId,
        });
        }
    }
  };

  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };
  const renderInput = (name, type = "text", size) => (
    <>
      <input
        type={type}
        name={name}
        className={`createTime ${show ? "hide" : "show"}`}
        onChange={handleChange}
        style={{ width: size }}
      />
      <span className={`bookinginput ${!show ? "hide" : "show"}`}>
        &nbsp;{formData[name]}
      </span>
    </>
  );
  const renderSelect = (name, options, size) => (
    <>
      <select
        name={name}
        className={`createTime ${show ? "hide" : "show"}`}
        onChange={handleChange}
        style={{ border: "1px solid black", width: size }}
      >
        <option disabled selected>
          select
        </option>
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
      <span
        style={{ fontWeight: "400" }}
        className={`bookinginput ${!show ? "hide" : "show"}`}
      >
        &nbsp;{formData[name]}
      </span>
    </>
  );
  const renderTableTD = (value, options = {}) => {
    const { style = { border: "1px solid black", textAlign: "center" } } =
      options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const { style = { border: "1px solid black", textAlign: "center" } } =
      options;
    return <th style={style}>{value}</th>;
  };

  const handlesubmit = () => {
    props.loaderchange("true");

    try {
      if (
        props.patientsData.id !== "" &&
        props.patientsData.p_uhid !== "" &&
        /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())
      ) {
        setshow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById(
            "etReportGenerateWrap"
          ).innerHTML;

          // Prepare payload for creating report
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: "",
              template_type: "ET Template",
            },
          };

          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
            };
            createNewAppointment();
          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate("/PatientView");
            Swal.fire({
              title: "Successful.",
              text: "Record added successful.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
            props.loaderchange("false");

          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <div id="EtTemplate">
      <div className="EtTemplate">
        <div
          className=""
          style={{ width: "100%", display: "block" }}
          id="patientInfo1"
        >
          <div style={{ width: "100%" }}>
            <img
              className="header_image"
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: "100%",
                margin: "0 auto",
              }}
            ></img>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={props.patientsData.p_uhid}
                  onChange={(e) => handleChange(e)}
                  name="patientId"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.p_uhid}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name="patientName"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={props.patientsData.gender}
                  name="gender"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.gender}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={props.patientsData.age}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{props.patientsData.age}
              </span>
            </div>
          </div>
          <div className="detail">
            <p>SCAN DAY 2/ 3</p>
            <div style={{ display: "flex" }}>
              <p>ET : {renderInput("et")}</p>
              <p>RT : {renderInput("rt")}</p>
              <p>LT : {renderInput("lt")}</p>
            </div>
            <div style={{ display: "flex" }}>
              <p>TRIAL : {renderInput("trial")}</p>
            </div>
            <div style={{ display: "flex" }}>
              <p>HYSTEROSCOPY : {renderInput("hysteroscopy")}</p>
            </div>
            <div style={{ display: "flex" }}>
              <p>DOXY /ECOTAS : {renderInput("doxyEcotas")}</p>
            </div>
            <div style={{ display: "flex" }}>
              <p>ET AT OPU : {renderInput("etAtOpu")}</p>
            </div>
            <div style={{ display: "flex" }}>
              <p>
                COMORBIDS : {renderSelect("comorbids", ["DM", "HT", "Others"])}
              </p>
            </div>
            <div style={{ display: "flex" }}>
              <p>EMBRYO NUMBER: {renderInput("embryoNumber")}</p>
            </div>
            <p>GRADE</p>
            <div style={{ display: "flex" }}>
              <p>PROL : {renderInput("prol")}</p>
              <p>E2 : {renderInput("e2")}</p>
              <p>TSH : {renderInput("tsh")}</p>
            </div>
            <div style={{ display: "flex" }}>
              <p>HBA1C : {renderInput("hba1c")}</p>
            </div>
          </div>
        </div>
        <div className="detail">
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                {[
                  "SI No.",
                  "MEDICINE",
                  "DOSE",
                  "FREQUENCY",
                  "ROUTE",
                  "DAYS",
                  "Relationship With Food",
                ].map((ele) => renderTableTH(ele))}
              </tr>
            </thead>
            <tbody>
              {[
                "T.PROGYNOVA",
                "TAB.FOLSAFE L",
                "TAB. ECOSPRIN 75/150",
                "ARGIPRIMESACHET",
                "T.TRICIUMXT/SHELCAL/CALCIUM",
                "ESTOGEL",
                "T.SILDENAFIL",
              ].map((ele, i) => (
                <tr key={i}>
                  {renderTableTH(i + 1)}
                  {renderTableTH(ele)}
                  {renderTableTD(renderInput(`dose${i}`))}
                  {renderTableTD(renderInput(`frequency${i}`))}
                  {renderTableTD(renderInput(`route${i}`))}
                  {renderTableTD(renderInput(`days${i}`))}
                  {renderTableTD(renderInput(`relationshipWithFood${i}`))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p style={{fontWeight:"600"}}>
NEXT APPOINTMENT -{" "}
<input
name="nextappointment"
onChange={handleChange}
type="datetime-local"
// type="date"
/>
</p>
        <div className={`Footer ${show ? "hide" : "show"}`}>
          <button onClick={handlesubmit} className="Button_Create">
            Add Report
          </button>
        </div>
      </div>

      <div id="etReportGenerate">
        <div id="etReportGenerateWrap">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h4>SCAN DAY 2/ 3</h4>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield("ET :", formData.et)}
            {renderReportfield("RT :", formData.rt)}
            {renderReportfield("LT :", formData.lt)}
            {renderReportfield("TRIAL :", formData.trial)}
            {renderReportfield("HYSTEROSCOPY :", formData.hysteroscopy)}

          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield("DOXY /ECOTAS :", formData.doxyEcotas)}
            {renderReportfield("ET AT OPU :", formData.etAtOpu)}
            {renderReportfield("COMORBIDS :", formData.comorbids)}
          {renderReportfield("EMBRYO NUMBER :", formData.embryoNumber)}
              
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h4>GRADE</h4>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield("PROL :", formData.prol)}
            {renderReportfield("E2 :", formData.e2)}
            {renderReportfield("TSH :", formData.tsh)}
            {renderReportfield("HBA1C :", formData.hba1c)}
          </div>

          <div>
            <table style={{ width: "100%" }}>
              <tr>
                {[
                  "SI No.",
                  "MEDICINE",
                  "DOSE",
                  "FREQUENCY",
                  "ROUTE",
                  "DAYS",
                  "Relationship With Food",
                ].map((ele) => renderTableTH(ele))}
              </tr>
              <tbody>
                {[
                  "T.PROGYNOVA",
                  "TAB.FOLSAFE L",
                  "TAB. ECOSPRIN 75/150",
                  "ARGIPRIMESACHET",
                  "T.TRICIUMXT/SHELCAL/CALCIUM",
                  "ESTOGEL",
                  "T.SILDENAFIL",
                ].map((ele, i) => (
                  <tr key={i}>
                    {renderTableTH(i + 1)}
                    {renderTableTH(ele)}
                    {renderTableTD(formData[`dose${i}`])}
                    {renderTableTD(formData[`frequency${i}`])}
                    {renderTableTD(formData[`route${i}`])}
                    {renderTableTD(formData[`days${i}`])}
                    {renderTableTD(formData[`relationshipWithFood${i}`])}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: "10px" }}>
{renderReportfield("Next Appointment : ",appointmentData.date?.split("-").reverse().join("-"))}
</div>
          <p class="Dani"></p>
        <PrescriptionFooter/>
        </div>
      </div>
    </div>
  );
}
